import { tabNames, TRAFFIC_FILTER } from '@va/constants';
import { getTrafficFilter } from '@va/dashboard/selectors/ui';
import { PageContent, PageHeaderItemsWrapper } from '@va/dashboard/shared/ui-layout';
import { useActiveTab, usePageHeaderProps } from '@va/dashboard/util-hooks';
import { RefreshButton } from '@va/ui/components/buttons';
import { useRefreshContext } from '@va/util/components';
import TrafficFilter from 'common/components/misc/TrafficFilter/TrafficFilter';
import { useMemo } from 'react';
import { useSelector } from 'react-redux';
import TrafficPastWeekPanel from './TrafficPastWeekPanel';
import TrafficPastYearsPanel from './TrafficPastYearsPanel';

export const TrafficChartsTab = () => {
  useActiveTab(tabNames.trafficCharts);

  const trafficFilter = useSelector(getTrafficFilter);
  const { manualRefresh } = useRefreshContext();

  const pageHeaderProps = useMemo(() => ({ hideDatePicker: true }), []);

  usePageHeaderProps(pageHeaderProps);

  return (
    <>
      <PageHeaderItemsWrapper>
        <div className='max-w-[98vw] flex flex-nowrap items-center gap-3 overflow-x-auto scrollbar scrollbar-thumb'>
          <RefreshButton
            refreshFn={() => {
              manualRefresh();
            }}
          />
          <TrafficFilter refreshFn={() => {}} />
        </div>
      </PageHeaderItemsWrapper>

      <PageContent className='traffic-charts'>
        <div className='space-y-7'>
          {trafficFilter.period === TRAFFIC_FILTER.PAST_WEEK ? <TrafficPastWeekPanel /> : <TrafficPastYearsPanel />}
        </div>
      </PageContent>
    </>
  );
};
